<template>
  <div class="talleres-festival-page">
    <div class="container">

      <!-- Header -->
      <div class="festival-header">
        <span class="programa-label">Programa Febrero - Marzo</span>
        <h1 class="festival-title">Festival Arena y Barro</h1>
        <span class="aniversario">30 años</span>
      </div>

      <!-- Talleres Grid -->
      <div class="talleres-grid">

        <div
          v-for="taller in talleres"
          :key="taller.id"
          class="taller-card"
          :class="{
            'taller-featured': taller.featured,
            'taller-passed': isPast(taller.date)
          }"
        >
          <div class="taller-sala">Sala</div>
          <div v-if="isPast(taller.date)" class="passed-badge">Finalizado</div>
          <div class="taller-fecha">{{ taller.fechaDisplay }}</div>
          <h3 class="taller-instructor">{{ taller.instructor }} <span v-if="taller.origin" class="taller-origin">- {{ taller.origin }}</span></h3>
          <p class="taller-tema">{{ taller.tema }}</p>
        </div>

      </div>

      <!-- Duration Note -->
      <p class="duracion-note">Todos los talleres tienen una duración de 3 horas por día</p>

      <!-- Contact CTA -->
      <div class="contact-cta">
        <p class="contact-text">Por más información de costos de espectáculos y talleres</p>
        <a href="https://wa.me/59899409402" target="_blank" rel="noopener" class="contact-btn">
          <span class="whatsapp-icon">📱</span>
          Escribinos por privado
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TalleresFestivalPage',
  data() {
    return {
      talleres: [
        {
          id: 1,
          instructor: 'Ernesto Díaz',
          origin: null,
          tema: 'Música',
          date: '2026-02-14',
          fechaDisplay: 'Sábado 14 de Febrero - 10:00 h',
          featured: false
        },
        {
          id: 2,
          instructor: 'Silvina Migliónico',
          origin: null,
          tema: 'Expresión vocal y canto',
          date: '2026-02-21',
          fechaDisplay: 'Sábado 21 de Febrero - 10:00 h',
          featured: false
        },
        {
          id: 3,
          instructor: 'Luciano Dractta',
          origin: 'Brasil',
          tema: 'Intensivo de Clown',
          date: '2026-02-28',
          fechaDisplay: 'Sábado 28 de Febrero - 10:00 h',
          featured: true
        },
        {
          id: 4,
          instructor: 'Fernando Toja',
          origin: null,
          tema: 'Teatro',
          date: '2026-03-07',
          fechaDisplay: 'Sábado 07 de Marzo - 10:00 h',
          featured: false
        },
        {
          id: 5,
          instructor: 'Fernando Toja',
          origin: null,
          tema: 'Teatro',
          date: '2026-03-08',
          fechaDisplay: 'Domingo 08 de Marzo - 10:00 h',
          featured: false
        }
      ]
    }
  },
  methods: {
    isPast(dateStr) {
      const showDate = new Date(dateStr + 'T23:59:59')
      const today = new Date()
      return showDate < today
    }
  }
}
</script>

<style scoped>
.talleres-festival-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Festival Header */
.festival-header {
  text-align: center;
  margin-bottom: 50px;
}

.programa-label {
  display: block;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #c9a227;
  margin-bottom: 10px;
}

.festival-title {
  font-size: 42px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.aniversario {
  display: inline-block;
  font-size: 18px;
  color: #c9a227;
  font-style: italic;
}

/* Talleres Grid */
.talleres-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 25px;
  margin-bottom: 40px;
}

/* Taller Card */
.taller-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #333;
  border-radius: 10px;
  padding: 25px;
  transition: all 0.3s ease;
}

.taller-card:hover {
  border-color: #c9a227;
  background: rgba(201, 162, 39, 0.05);
}

/* Passed talleres */
.taller-passed {
  opacity: 0.5;
  filter: grayscale(50%);
}

.taller-passed:hover {
  border-color: #333;
  background: rgba(255, 255, 255, 0.03);
  opacity: 0.5;
}

.passed-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #666;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.taller-featured {
  grid-column: 1 / -1;
  background: rgba(201, 162, 39, 0.1);
  border-color: #c9a227;
}

.taller-sala {
  position: absolute;
  top: -10px;
  left: 20px;
  background: #c9a227;
  color: #000;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 3px;
  text-transform: uppercase;
}

.taller-fecha {
  font-size: 14px;
  color: #888;
  margin-bottom: 12px;
  padding-top: 5px;
}

.taller-instructor {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 8px 0;
}

.taller-origin {
  font-weight: 400;
  color: #c9a227;
  font-size: 20px;
}

.taller-tema {
  font-size: 16px;
  color: #aaa;
  margin: 0;
  font-style: italic;
}

/* Duration Note */
.duracion-note {
  text-align: center;
  font-size: 16px;
  color: #c9a227;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 50px;
  font-style: italic;
}

/* Contact CTA */
.contact-cta {
  background: #c9a227;
  padding: 40px;
  border-radius: 10px;
  text-align: center;
}

.contact-text {
  font-size: 18px;
  color: #000;
  margin: 0 0 20px 0;
  font-weight: 500;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #000;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background: #222;
  transform: scale(1.05);
}

.whatsapp-icon {
  font-size: 22px;
}

/* Mobile */
@media (max-width: 767px) {
  .talleres-festival-page {
    padding: 40px 0 60px;
  }

  .festival-title {
    font-size: 28px;
  }

  .aniversario {
    font-size: 16px;
  }

  .talleres-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .taller-featured {
    grid-column: 1;
  }

  .taller-card {
    padding: 20px;
  }

  .taller-instructor {
    font-size: 20px;
  }

  .taller-origin {
    font-size: 16px;
  }

  .duracion-note {
    font-size: 14px;
  }

  .contact-cta {
    padding: 30px 20px;
  }

  .contact-text {
    font-size: 16px;
  }

  .contact-btn {
    font-size: 16px;
    padding: 12px 25px;
  }
}
</style>